module.exports = __webpack_public_path__ + "img/p2.08ff400.png";